import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { ModalWindow, Checkbox, useLocalizeMessage } from 'libs.nucleus';
export const ChartPresetsFilter = ({ isOpen, onClose, applyFilters, filterData, initialSelectedOptions, }) => {
    const translate = useLocalizeMessage();
    const [selectedOptions, setSelectedOptions] = useState(initialSelectedOptions || []);
    const options = filterData.options.map((preset) => preset.option);
    const savePrimaryButton = {
        label: 'Apply',
        onClick: () => {
            const payload = selectedOptions.map((selectedOption) => {
                const preset = filterData.options.find((option) => option.option.value === selectedOption.value);
                return preset;
            });
            applyFilters({ selectedOptions: payload });
        },
    };
    const handleSelect = (checked, option) => {
        if (checked) {
            setSelectedOptions([...selectedOptions, option]);
        }
        else {
            setSelectedOptions(selectedOptions.filter((selectedOption) => selectedOption.value !== option.value));
        }
    };
    const handleClearAll = () => {
        setSelectedOptions([]);
    };
    return (_jsx(ModalWindow, { title: 'Filter report card', subtitle: 'Here are some filters that can be applied to this card:', isOpen: isOpen, closeWindow: onClose, footerPrimaryActionButton: savePrimaryButton, footerSecondaryActionButtons: [
            {
                label: 'Cancel',
                onClick: onClose,
            },
        ], children: _jsx("div", { className: 'relative px-4 min-h-[100px]', children: !!options.length && (_jsxs("div", { className: 'space-y-2', children: [selectedOptions.length > 0 && (_jsx("button", { className: 'text-sm text-blue-600 hover:text-blue-800 underline mb-2', onClick: handleClearAll, children: translate('Clear all selections') })), options.map((option) => (_jsx(Checkbox, { label: option.label, onChange: (checked) => handleSelect(checked, option), checked: selectedOptions.find((selectedOption) => selectedOption.value === option.value) !== undefined }, option.value)))] })) }) }));
};
